export default __webpack_public_path__ + "static/wifi-router-8035c4640942ea2aaa2fbb090728eca0.png";